import React from 'react';
import { CoverageHistoryChart } from '../CoverageHistoryChart/CoverageHistoryChart.esm.js';
import { FileExplorer } from '../FileExplorer/FileExplorer.esm.js';
import { Page, Content, ContentHeader } from '@backstage/core-components';

const CodeCoveragePage = () => {
  return /* @__PURE__ */ React.createElement(Page, { themeId: "tool" }, /* @__PURE__ */ React.createElement(Content, null, /* @__PURE__ */ React.createElement(ContentHeader, { title: "Code coverage" }), /* @__PURE__ */ React.createElement(CoverageHistoryChart, null), /* @__PURE__ */ React.createElement(FileExplorer, null)));
};

export { CodeCoveragePage };
//# sourceMappingURL=CodeCoveragePage.esm.js.map
